// Function to remove invalid role="group" from slide links
function removeInvalidRolesFromSlides(swiperInstance) {
    if (!swiperInstance || !swiperInstance.slides) return;
    swiperInstance.slides.forEach(function(slide) {
        if (slide.tagName === 'A' && slide.hasAttribute('role')) {
            slide.removeAttribute('role');
        }
    });
}

var swiper = new Swiper(".page-header__slider .mySwiper", {
  slidesPerView: 2,
  spaceBetween: 15,
  autoHeight: true,
  a11y: {
      enabled: false // Disable Swiper's accessibility features that add invalid roles
  },
  navigation: {
      nextEl: ".page-header__slider .swiper-button-next",
      prevEl: ".page-header__slider .swiper-button-prev",
  },
  breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1440: {
          slidesPerView: 3,
          spaceBetween: 15,
      },
    },
    on: {
        init: function() {
            var self = this;
            // Remove invalid role="group" from slide links for accessibility
            removeInvalidRolesFromSlides(self);
            // Use MutationObserver to watch for role attribute changes
            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'role') {
                        var target = mutation.target;
                        if (target.tagName === 'A' && target.hasAttribute('role')) {
                            target.removeAttribute('role');
                        }
                    }
                });
            });
            // Observe all slides for attribute changes
            self.slides.forEach(function(slide) {
                if (slide.tagName === 'A') {
                    observer.observe(slide, { attributes: true, attributeFilter: ['role'] });
                }
            });
            // Store observer on swiper instance for cleanup if needed
            self._roleObserver = observer;
        },
        slideChange: function() {
            // Remove invalid role="group" from slide links after slide change
            removeInvalidRolesFromSlides(this);
        },
        resize: function() {
            // Remove invalid role="group" from slide links after resize
            removeInvalidRolesFromSlides(this);
        }
    }
});

// Also run removal after a short delay to catch any late additions
setTimeout(function() {
    var slider = document.querySelector(".page-header__slider .mySwiper");
    if (slider && slider.swiper) {
        removeInvalidRolesFromSlides(slider.swiper);
    }
}, 100);